import { useMemo } from 'react';
import { useReportingThemes } from 'reporting-visualizations/hooks/useReportingThemes';
import { THEME } from 'reporting-data/tsTypes/visualization/colors';
import { isListTheme } from 'reporting-visualizations/color/themes';
export const useIconColors = () => {
  const reportingThemes = useReportingThemes();
  const multiColorTheme = useMemo(() => {
    const theme = reportingThemes.get(THEME.MULTI);
    return isListTheme(theme) ? theme.toArray() : [];
  }, [reportingThemes]);
  const colorCount = multiColorTheme.length;
  if (colorCount < 1) {
    return null;
  }
  return {
    orange: multiColorTheme[0],
    purple: colorCount > 1 ? multiColorTheme[1] : multiColorTheme[colorCount - 1],
    aqua: colorCount > 2 ? multiColorTheme[2] : multiColorTheme[colorCount - 1],
    yellow: colorCount > 3 ? multiColorTheme[3] : multiColorTheme[colorCount - 1]
  };
};